const ctrl = [
    '$rootScope',
    '$route',
    '$location',
    'ProductsFactory',
    'ReleasesFactory',
    'UserFactory',
];

class DisabledCtrl {
    constructor(
        $rootScope,
        $route,
        $location,
        ProductsFactory,
        ReleasesFactory,
        UserFactory
    ) {
        this.$rootScope = $rootScope;
        this.$route = $route;
        this.$location = $location;
        this.ProductsFactory = ProductsFactory;
        this.ReleasesFactory = ReleasesFactory;
        this.UserFactory = UserFactory;

        this.product = {};
        this.releases = {};
        this.meta = {};

        this.setup();

        this.$rootScope.$on('ProductsFetched', () => this.setup());
        this.$rootScope.$on('ReleasesFetched', () => this.setup());
    }

    goto(path) {
        this.$location.path(path);
    }

    gotoReleaseList() {
        this.goto(`/${this.product.static_name}`);
    }

    isLoggedIn() {
        return this.UserFactory.isLoggedIn();
    }

    hasGuideLink() {
        if(!this.release) {
            return;
        }

        return !!this.release.guide_link;
    }

    download(file) {
        return this.isLoggedIn() ? this.downloadLoggedIn(file) : this.downloadNotLoggedIn(file);
    }

    downloadLoggedIn(file) {
        return `/api/download/release/${this.release.id}/${file}`;
    }

    downloadNotLoggedIn(file) {
        return `/api/public/download/release/${this.release.id}/${file}`;
    }

    _fetchRelease() {
        const id = this.$route.current.params.releaseId;

        return this.ReleasesFactory.findById(id) || {};
    }

    _fetchProduct(id) {
        return this.ProductsFactory.findById(id) || {};
    }

    _setMeta() {
        this.meta.released = this.ReleasesFactory.humanizeDate(this.release.release_date);
        this.meta.built = this.ReleasesFactory.humanizeDate(this.release.build_date);
    }

    _setCrumbs() {
        this.crumbs = [
            {
                text: 'Products & Editions',
                link: '/',
            },
            {
                text: 'Release List',
                link: `/${this.product.static_name}`,
            },
            {
                text: `${this.product.name} v${this.release.version}`,
            },
        ];
    }

    setup() {
        this.release = this._fetchRelease();

        if(!Object.keys(this.release).length) {
            return;
        }

        this.product = this._fetchProduct(this.release.product_id);

        this._setMeta();
        this._setCrumbs();
    }
}

ctrl.push(DisabledCtrl);

export default ctrl;



// WEBPACK FOOTER //
// ./resources/assets/app-releases/controllers/ReleaseCtrl.js